function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6882 11.6667V5H4.19482V35H37.1817V11.6667H20.6882ZM10.7922 31.6667H7.49351V28.3333H10.7922V31.6667ZM10.7922 25H7.49351V21.6667H10.7922V25ZM10.7922 18.3333H7.49351V15H10.7922V18.3333ZM10.7922 11.6667H7.49351V8.33333H10.7922V11.6667ZM17.3896 31.6667H14.0909V28.3333H17.3896V31.6667ZM17.3896 25H14.0909V21.6667H17.3896V25ZM17.3896 18.3333H14.0909V15H17.3896V18.3333ZM17.3896 11.6667H14.0909V8.33333H17.3896V11.6667ZM33.883 31.6667H20.6882V28.3333H23.9869V25H20.6882V21.6667H23.9869V18.3333H20.6882V15H33.883V31.6667ZM30.5843 18.3333H27.2856V21.6667H30.5843V18.3333ZM30.5843 25H27.2856V28.3333H30.5843V25Z",
  fill: "#767B7F"
});

function SvgEducationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education-icon.74daf40a.svg";
export { ForwardRef as ReactComponent };